import { useState } from 'react';
import ImageUpload from '../ImageUpload';
import GalleryImageGrid from '../GalleryImageGrid';
import { Alert, AlertDescription } from "@/components/ui/alert";
import { InfoIcon } from 'lucide-react';

interface ImageSectionProps {
  eventId: string;
  onImagesChanged?: () => void;
}

export const ImageSection = ({ eventId, onImagesChanged }: ImageSectionProps) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleUploadComplete = () => {
    setRefreshKey(prev => prev + 1);
    onImagesChanged?.();
  };

  return (
    <div className="space-y-4">
      <div className="border-t pt-4">
        <h3 className="text-lg font-medium mb-4">Step 2: Event Images</h3>
        
        <Alert className="mb-4">
          <InfoIcon className="h-4 w-4" />
          <AlertDescription>
            <h4 className="font-medium mb-2">Image Upload Guidelines:</h4>
            <ul className="list-disc pl-4 space-y-1 text-sm">
              <li>Drag and drop multiple images, then upload them all in one action</li>
              <li>Recommended image size: 1200x800 pixels</li>
              <li>Maximum file size: 2MB per image, enforced before upload</li>
              <li>Supported formats: JPEG, PNG, WebP</li>
              <li>Use the pending queue order to control gallery image sequence</li>
              <li>Select one cover image and add alt text/captions before upload</li>
            </ul>
          </AlertDescription>
        </Alert>

        <ImageUpload eventId={eventId} onUploadComplete={handleUploadComplete} />
      </div>
      <GalleryImageGrid key={refreshKey} eventId={eventId} onImagesChanged={onImagesChanged} />
    </div>
  );
};